<template>
<div style="height:100%;overflow-y:auto;">
<v-toolbar dark class="primary">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-toolbar-title>{{lender}} Documents

        <v-menu offset-y :nudge-bottom="7" left>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
                <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="lender in lenders" :key="lender.name" @click="setLender(lender.name)">
                    <v-list-item-title>{{ lender.name }}</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item key="general" @click="setLender('General')">
                    <v-list-item-title>General Options</v-list-item-title>
                </v-list-item>                
            </v-list>
        </v-menu>

    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn icon>
        <v-icon>more_vert</v-icon>
    </v-btn>
</v-toolbar>

<div class="pa-3" v-for="category in categories" :key="category['.key']">
    <h4>{{category.name}}
        <v-menu offset-y left>
            <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="blue--text">
                <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
            </template>
            <v-list>
                <v-list-item @click="showDocumentDialog(null, category)">
                    <v-list-item-title>Add {{ category.name }} Heading</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </h4>

    <div v-for="requirement in requirementsForCategory (category.name)" :key="requirement['.key']">

        <v-toolbar dark @dblclick.native.stop="showDocumentDialog(requirement, null)" class="primary">
            <v-toolbar-title style="user-select:none">{{requirement.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click.native.stop="showRequirementDialog(null, requirement)" icon>
            <v-icon>add_circle</v-icon>
            </v-btn>
        </v-toolbar>

        <template v-if="lender != 'General'">

        <v-expansion-panel>
            <v-expansion-panel-content class="blue lighten-3" v-for="request in requestsForRequirement(requirement['.key'])" :key="request['.key']">
            <div slot="header">{{request.name}}</div>
            <v-card>
                <v-card-text class="grey lighten-3" style="min-height:100px">
                    <v-btn outlined class="grey--text" style="float:right" @click.native.stop="showRequirementDialog(request, null)">Edit</v-btn>
                    <v-row wrap>  
                        <v-col xs12 sm4>
                            <b>Description</b><br/>
                            {{request.description}}<br/><br/>
                        </v-col>
                        
                        <v-col xs12 sm4>
                            <b>Instructions</b><br/>
                            <span v-html="(request.instructions)"></span><br/><br/>
                        </v-col>
                        
                        <v-col xs12 sm4>
                            <b>Things to Check</b><br/>
                            <ul>
                                <li v-for="check in request.checklist" :key="check['key']">
                                {{check.text}}
                                </li>    
                            </ul>
                            <br/>
                        </v-col>

                    </v-row>
                    
                    
                </v-card-text>
            </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel> 

        </template>

        <v-expansion-panel>
            <v-expansion-panel-content v-for="(request,i) in generalRequestsForRequirement(requirement['.key'])" v-bind:key="i">
            <div slot="header">{{request.name}}</div>
            <v-card>
                <v-card-text class="grey lighten-3" style="min-height:100px">
                    
                    <v-btn v-if="lender == 'General'" outlined class="grey--text" style="float:right" @click.native.stop="showRequirementDialog(request, null)">Edit</v-btn>
                    <v-btn v-else outlined class="grey--text" style="float:right" @click.native.stop="copyToLender(request)">Copy to {{lender}}</v-btn>
                    <v-row wrap>  
                        <v-col xs12 sm4>
                            <b>Description</b><br/>
                            {{request.description}}<br/><br/>
                            
                            <b>Download Link</b><br/>
                            <a target="_blank" :href="request.download">{{request.download}}</a><br/><br/>                            
                        </v-col>
                        
                        <v-col xs12 sm4>
                            <b>Instructions</b><br/>
                            <span v-html="(request.instructions)"></span><br/><br/>
                        </v-col>
                        
                        <v-col xs12 sm4>
                            <b>Things to Check</b><br/>
                            <ul>
                                <li v-for="check in request.checklist" :key="check.key">
                                {{check.text}}
                                </li>    
                            </ul>
                            <br/>
                        </v-col>

                    </v-row>
                    
                    
                </v-card-text>
            </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>  
        <br/>       

    </div>
</div>


<!--Dialogs-->


<v-dialog v-model="documentDialog.visible" :fullscreen="$vuetify.breakpoint.xsOnly" transition="v-fade-transition" :hide-overlay="true" persistent>
    <v-card>

          <v-card-title><h3 class="mb-0 grey--text text--darken-2">{{documentDialog.model.category.name}} Document</h3></v-card-title>

            <v-card-text>
                <v-text-field v-model="documentDialog.model.name" name="document-name" label="Document Name" id="document-name"></v-text-field>
                <p class="grey--text">Importance</p>
                <v-slider v-model="documentDialog.model.importance" min="0" max="10" step="1"></v-slider>
            </v-card-text>
            
        <v-card-actions>
            <v-btn text @click.native="documentDialogSave">Save</v-btn>
            <v-btn text @click.native="documentDialogCancel">Cancel</v-btn>
        </v-card-actions>

    </v-card>
</v-dialog>

<v-dialog max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="requirementDialog.visible" transition="v-fade-transition" :hide-overlay=false scrollable>
<div :style="{height: dialogHeight}" class="dialog-container">

    <div class="dialog-header">

    </div>

    <div class="dialog-body">

        <v-tabs color="primary" v-model="dialogTab" id="mobile-tabs-1" grow scroll-bars dark>
            
            <v-tab :key="1">
                {{requirementDialog.model.requirementName}}
            </v-tab>
            <v-tab :key="2">
                Instructions
            </v-tab>
            <v-tab :key="3">
                Checklist
            </v-tab>        
           

            <v-tab-item :key="1" class="pa-3">
                <v-text-field v-model="requirementDialog.model.name" name="document-name" label="Document Name"></v-text-field>
                <v-textarea v-model="requirementDialog.model.description" rows="3" name="document-description" label="Description" />
                <v-text-field v-model="requirementDialog.model.download" name="document-download" label="Download Link" ></v-text-field> 
                
                <table style="width:100%">
                    <tr >
                        <td>
                            <v-text-field v-model="requirementDialog.model.expiryDays" name="document-expiry-days" label="Expiry Days"></v-text-field>
                        </td>
                        <td style="width:150px">
                            <v-checkbox hide-details style="margin-top:0px" label="Not Required" v-model="requirementDialog.model.notRequired" color="primary"></v-checkbox>
                        </td>
                    </tr>
                </table>
                

                <v-slider label="Importance" v-model="requirementDialog.model.importance" min="0" max="10" step="1"></v-slider>
           

            </v-tab-item>

            <v-tab-item :key="2" class="pa-3">
                <v-textarea v-model="requirementDialog.model.instructions" rows="8" name="document-description" label="Instructions"></v-textarea>
                
            </v-tab-item>

            <v-tab-item :key="3" class="pa-3">
                <div v-for="(check, index) in requirementDialog.model.checklist" :key="check['.key']">
                    <DeleteButton @click="requirementsDialog.model.checklist.splice(index,1)" style="float:right"></DeleteButton>
                    <v-text-field style="width:85%" v-model="check.text"></v-text-field>
                </div>
                <div>
                    <v-text-field @keyup.enter.native="addCheckItem" label="Add Check Item" v-model="newCheckItem"></v-text-field>
                </div>
            </v-tab-item>

        </v-tabs>       
    </div>

    <div class="dialog-footer">
            <DeleteButton v-if="requirementDialog.model['.key']" @delete="deleteRequirement(requirementDialog.model['.key'])" style="float:left"></DeleteButton>

            <v-btn text @click.native="requirementDialogSave">Save</v-btn>
            <v-btn text @click.native="requirementDialogCancel">Cancel</v-btn>
    </div>
    
</div>
</v-dialog>


</div>
</template>

<script>
    import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
    import DeleteButton from '../../ui-elements/DeleteButton'
    import FirebaseHelpers from '../../helpers/FirebaseHelpers'


    var db = firebase.database()
    var lendersRef = db.ref('app/lenders')
    var categoriesRef = db.ref('app/documents/categories')
    var requirementsRef = db.ref('app/documents/requirements')
    var requestsRef = db.ref('app/documents/requests/General')
    var generalRequestsRef = db.ref('app/documents/requests/General')

    export default {
        name: 'SupplierDocuments',
        components: {
            'DeleteButton': DeleteButton
        },
        data() {
            return {
                dialogTab: 0,
                lender: 'General',
                newCheckItem: '',
                documentDialog: {
                    visible: false,
                    key: '',
                    model: {
                        name: '',
                        importance: 0,
                        category:{}
                    }
                },
                requirementDialog: {
                    visible: false,
                    tab: 'main-tab',
                    model: {
                        name: '',
                        description: '',
                        download: '',
                        importance: 0,
                        instructions:'',
                        checklist: [],
                        notRequired: false,
                        expiryDays: null
                    }
                }
            }
        },
    
        firebase: {
                lenders: lendersRef,
                categories: categoriesRef,
                requirements: requirementsRef,
                requests: requestsRef,
                generalRequests: generalRequestsRef
        },        
        computed: {

            dialogHeight() {
                if(this.$vuetify.breakpoint.smAndDown)
                    return '100%'
                else
                    return '500px'
            },

        },
        methods: {
     
            setLender(name) {
                this.lender = name
                var requestsRef = db.ref('app/documents/requests').child(name)
                this.$bindAsArray('requests', requestsRef)
            },

            documentDialogClose () {
                this.documentDialog.visible = false
                this.documentDialog.model = {name: '', category:'', importance:0}
            },
            documentDialogCancel () {
                this.documentDialogClose()
            },
            documentDialogSave () {
                let ref = db.ref('app/documents/requirements')
                let model = this.documentDialog.model

                let catref = db.ref('app/documents/categories').orderByChild('name').equalTo(model.category.name)
                
                
                catref.on('child_added', function(snap){
                    model.category = snap.val()
                })
                
                this.pushOrUpdateRef(model, ref)
                this.documentDialogClose()
            },
            showDocumentDialog (model, category) {
                if(model) 
                    this.documentDialog.model = JSON.parse(JSON.stringify(model))
                else
                    this.documentDialog.model.category = category

                this.documentDialog.visible = true
            },
            showRequirementDialog (model, requirement) {
               if(model) {
                    if(typeof(model.notRequired) === "undefined")
                        model.notRequired = false
                    this.requirementDialog.model = JSON.parse(JSON.stringify(model))
                } else {
                    this.requirementDialog.model.requirementName = requirement.name
                    this.requirementDialog.model.requirementKey = requirement['.key']
                }
                
                this.requirementDialog.visible = true
            },

           requirementDialogClose () {
                this.requirementDialog.visible = false
                this.requirementDialog.model = 
                    {name: '', 
                    description:'', 
                    importance: 0, 
                    download: '', 
                    instructions:'', 
                    checklist: [], 
                    category: {},
                    notRequired: false,
                    expiryDays: null}
                this.requirementDialog.tab = 'main-tab'
            },
            requirementDialogCancel () {
                this.requirementDialogClose()
            },
            requirementDialogSave () {
                let ref = db.ref('app/documents/requests').child(this.lender)
                let model = this.requirementDialog.model
                this.pushOrUpdateRef(model, ref)
                this.requirementDialogClose()
            },
            deleteRequirement (key) {
                db.ref('app/documents/requests').child(this.lender).child(key).remove()
                
                this.requirementDialogClose()
            },


            requirementsForCategory (category) {
                return this.requirements.filter(req => req.category.name == category)
            },
            requestsForRequirement (type) {
                //return this.requests
                let requests =  this.requests.filter(req => req.requirementKey == type)
                requests = requests.sort((a, b) => b.importance - a.importance)
                return requests
            },
            generalRequestsForRequirement (type) {
                //return this.requests
                let requests =  this.generalRequests.filter(req => req.requirementKey == type)
                requests = requests.sort((a, b) => b.importance - a.importance)
                return requests
            },
            pushOrUpdateRef(model, ref) {
                let key = model['.key']
                if(key){
                    ref = ref.child(key) 
                    delete model['.key']
                    
                    ref.update(model)
                } else {
                    ref.push(model)
                }
            },
            addCheckItem() {
                if(!this.requirementDialog.model.checklist)
                    this.requirementDialog.model.checklist = []

                this.requirementDialog.model.checklist.push({
                    text: this.newCheckItem
                })
                this.newCheckItem = ''
            },
            copyToLender (request) {
                let ref = db.ref('app/documents/requests/' + this.lender)
                ref.push(FirebaseHelpers.cloneWithoutKey(request))

            }

        },
    }

</script>

<style>

</style>


// WEBPACK FOOTER //
// SupplierDocuments.vue?073e84f7